import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
import RCore from 'RCore';
import config from 'cfg';
import SMStream from '../SMStream';

class EISMStream extends SMStream {
    renderToolbar() {
        return <h1>Incidents</h1>;
    }

    mapTo = (groupKey, event, incident) => ({
        name: 'IncidentWidget',
        groupKey,
        props: {
            'data-event-id': event.eventId,
            'data-incident-id': incident.incidentId
        },
        key: 'i' + incident.incidentId
    });

    mapToAnimatedGoal = (groupKey, event, incident) => ({
        name: 'AnimatedGoal',
        groupKey,
        props: {
            'data-event-id': event.eventId,
            'data-incident-id': incident.incidentId
        },
        key: 'animated-goal-i' + incident.incidentId
    });

    mapToAnimatedIncident = (groupKey, event, incident) => ({
        name: 'AnimatedIncident',
        groupKey,
        props: {
            'data-event-id': event.eventId,
            'data-incident-id': incident.incidentId
        },
        key: 'animated-incident-i' + incident.incidentId
    });

    loadSMWidgets = params => {
        let { eventId } = params;
        return RCore.promiseProps({
            event: fetch(`${config.apis.ss2}/events/${eventId}`).then(response => response.json())
        }).then(result => {
            let { event } = result;
            return [
                ..._.chain(event.incidents)
                    .filter(i => i.subtype === 'goal' || i.subtype === 'goal_own')
                    .sortBy(i => -i.min)
                    .map(this.mapTo.bind(this, 'Goals Incidents', event)),

                ..._.chain(event.incidents)
                    .filter(i => i.subtype === 'card')
                    .sortBy(i => -i.min)
                    .map(this.mapTo.bind(this, 'Cards Incidents', event)),

                ..._.chain(event.incidents)
                    .filter(i => i.subtype === 'subst_in')
                    .sortBy(i => -i.min)
                    .map(this.mapTo.bind(this, 'Substitutions', event)),

                ..._.chain(event.incidents)
                    .filter(i => i.subtype === 'goal')
                    .sortBy(i => -i.min)
                    .map(this.mapToAnimatedGoal.bind(this, 'Animated Goal', event)),
                ..._.chain(event.incidents)
                    .filter(i => i.subtype === 'goal' || i.subtype === 'goal_own')
                    .sortBy(i => -i.min)
                    .map(this.mapToAnimatedIncident.bind(this, 'Animated Incident Goals', event)),
                ..._.chain(event.incidents)
                    .filter(i => i.subtype === 'card')
                    .sortBy(i => -i.min)
                    .map(this.mapToAnimatedIncident.bind(this, 'Animated Incident Cards', event))
            ];
        });
    };
}

export default EISMStream;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/streams/event/EventIncidentsSMStream.js
 **/